"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrideApiClientDefaults = exports.apiClient = exports.BASE_NAME = void 0;
var axios_1 = __importDefault(require("axios"));
var axios_case_converter_1 = __importDefault(require("axios-case-converter"));
var apiClientAuthMiddleware_1 = __importDefault(require("../utils/apiClientAuthMiddleware"));
exports.BASE_NAME = '/api';
var instance = axios_1.default.create({
    baseURL: process.env.INTERNAL_API_URL || exports.BASE_NAME,
    withCredentials: true
});
exports.apiClient = (0, apiClientAuthMiddleware_1.default)((0, axios_case_converter_1.default)(instance));
var overrideApiClientDefaults = function (config) {
    Object.keys(config).forEach(function (configKey) {
        exports.apiClient.defaults[configKey] = config[configKey];
    });
};
exports.overrideApiClientDefaults = overrideApiClientDefaults;
exports.default = exports.apiClient;
